__turbopack_context__.v({
  "CoreButton": "xaXzvq_CoreButton",
  "OutlineGradient1": "xaXzvq_OutlineGradient1",
  "ThemeDk": "xaXzvq_ThemeDk",
  "ThemeFw": "xaXzvq_ThemeFw",
  "Variant_Dark": "xaXzvq_Variant_Dark",
  "Variant_DarkOutline": "xaXzvq_Variant_DarkOutline",
  "Variant_Red": "xaXzvq_Variant_Red",
  "iconBack": "xaXzvq_iconBack",
  "inverse": "xaXzvq_inverse",
  "large": "xaXzvq_large",
  "outline": "xaXzvq_outline",
  "roundedSquare": "xaXzvq_roundedSquare",
  "square": "xaXzvq_square",
});
